<template>
<div class="feedbackTest mt-15">
  <div class="pb-5" v-if="!finishStep">
    <span>
      Перед тем как отправить ответ, вам нужно оставить свой комментарии по данному кейсу:
    </span>
    <br>
    <br>
    <span>
      - Понятна ли суть задания
      <br>
      - Логичны ли варианты ответов
      <br>
      - Есть ли ошибки или неточности
      <br>
    </span>
  </div>
  <div class="pb-5" v-else>
    <span>
      Здесь вы можете оставить свое общее впечатление по пройденному тесту
    </span>
    <br>
  </div>
  <v-textarea
    v-model="textFeedBack"
    :type="'input'"
    :placeholder="'Введите текст для обратной связи'"
    :dense="true"
    :outlined="true"
    :hide-details="true"
    @input="changeFeedBack"
  >
  </v-textarea>
  <v-btn
    v-if="finishStep"
    class="mt-5"
    dark color="primary"
    @click="sendFeedBack"
    :disabled="feedBackText.length < 2"
  >
    Отправить
  </v-btn>
</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

/**
 * Компонент: feedbackTest
 * Описание:
 */
export default {
  name: 'feedbackTest',

  components: {},

  props: {
    finishStep: {
      type: Boolean,
      default: () => false,
    }
  },
  emits: ['changeFeedBack'],

  data() {
    const textFeedBack = '';
    return {
      textFeedBack
    };
  },

  computed: {
    ...mapGetters({
      feedBackText: 'testing/testing/feedBackText',
      feedBackFinished: 'testing/testing/feedBackFinished'
    })
  },

  watch: {
    feedBackText(val) {
      this.textFeedBack = val;
    }
  },

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapMutations({
      setFeedBackText: 'testing/testing/setFeedBackText'
    }),
    ...mapActions({
      sendFeedBackText: 'testing/testing/sendFeedBackText'
    }),
    changeFeedBack() {
      this.setFeedBackText(this.textFeedBack);
    },
    sendFeedBack() {
      this.sendFeedBackText(true);
    }
  },
};
</script>

<style scoped lang="scss">
.feedbackTest {
  /* Стили компонента */
  & .v-textarea {
    ::v-deep .v-input__control{
      border-radius: 8px;
      border: 1px solid var(--color-grey-200);
    }
    &.full::v-deep textarea{
      height: 140px;
      border-radius: 20px;
      padding-left: 8px;
    }
    ::v-deep textarea{
      height: 80px;
      border-radius: 20px;
      padding-left: 8px;
    }
  }
}
</style>
